import React, { FC } from 'react';
import { TouchableHighlight, View } from 'react-native';

import { alertsTestIDs, Theme } from '@constants';
import { helpers } from '@helpers';
import { useContextReference, useNodeHandle } from '@hooks';

import { styles } from './styles';

import { FocusableHighlight } from '../../focusable/FocusableHighlight/FocusableHighlight';
import { TWCScrollView } from '../../primitives/TWCScrollView/TWCScrollView';
import { TWCText } from '../../primitives/TWCText/TWCText';

export const AlertShowDescription: FC<AlertShowDescriptionProps> = ({ data = null }) => {
  const focusReference = useContextReference<TouchableHighlight>(alertsTestIDs.pdpDescription.focusHandle);
  const focusHandle = useNodeHandle(focusReference);

  const noFocusTarget = helpers.isAndroid ? focusHandle : null;

  return (
    <View accessible={false} style={styles.wrapper}>
      <FocusableHighlight
        accessibilityHint={''}
        accessibilityLabel={`${data?.title ?? ''}. ${data?.description ?? ''}`}
        accessible
        nativeID={alertsTestIDs.pdpDescription.focusHandle}
        nextFocusDown={noFocusTarget}
        nextFocusLeft={noFocusTarget}
        nextFocusRight={noFocusTarget}
        nextFocusUp={noFocusTarget}
        ref={focusReference}
        style={styles.focusHandle}
        testID={alertsTestIDs.pdpDescription.focusHandle}
      >
        <View />
      </FocusableHighlight>
      <TWCText
        numberOfLines={1}
        style={styles.title}
        testID={alertsTestIDs.pdpDescription.showTitle}
        variant={'pageHeader'}
      >
        {data?.title}
      </TWCText>
      <TWCScrollView
        isFocused
        showLinearGradient
        gradientColors={[Theme.gradients.alertModal.start, Theme.colorFocusText]}
        scrollHeight={Theme.px(650)}
        scrollIncrement={Theme.px(120)}
        style={styles.scrollView}
        testID={alertsTestIDs.pdpDescription.scrollView}
      >
        <TWCText style={styles.description} testID={alertsTestIDs.pdpDescription.description} variant={'regularText29'}>
          {data?.description}
        </TWCText>
      </TWCScrollView>
    </View>
  );
};

type AlertShowDescriptionProps = {
  /** take type of data from "src/screens/PictureDetailedVODPage/PictureDetailedVODContentAPI/PictureDetailedVODContentAPI.js" */
  data: null | {
    title?: string;
    description?: string;
  };
};
